import { apiJson, type ApiFetchInit } from "../../api/client";
import type { CreateInvitationInput, Invitation } from "../types";

export function listInvitations(init: ApiFetchInit = {}): Promise<Invitation[]> {
  return apiJson<Invitation[]>("/team/invitations", init);
}

// reCAPTCHA is an upstream transport requirement, not part of the
// invitation domain model — keep it off `CreateInvitationInput` and
// thread it through a separate parameter at the request layer.
export interface CreateInvitationRecaptcha {
  token?: string | null;
  /** Skip captcha verification — used when the host couldn't issue a
   *  token (script load failed, running standalone, etc.). The upstream
   *  decides whether to honour it. */
  bypass?: boolean;
}

export function createInvitation(
  input: CreateInvitationInput,
  recaptcha?: CreateInvitationRecaptcha,
  init: ApiFetchInit = {},
): Promise<unknown> {
  const body: Record<string, unknown> = { ...input };
  if (recaptcha?.token) {
    body.tokenRecaptcha = recaptcha.token;
    body.isRecaptchaV3 = true;
  }
  if (recaptcha?.bypass) {
    body.bypassRecaptcha = true;
  }
  return apiJson("/team/invitations", {
    ...init,
    method: "POST",
    headers: { "Content-Type": "application/json", ...init.headers },
    body: JSON.stringify(body),
  });
}

export function withdrawInvitation(
  id: string | number,
  init: ApiFetchInit = {},
): Promise<Invitation> {
  return apiJson<Invitation>(`/team/invitations/${encodeURIComponent(String(id))}`, {
    ...init,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...init.headers },
    body: JSON.stringify({ status: "cancelled" }),
  });
}
